import * as mutationTypes from './mutation-types'
import api from '@/store/api/search'
import {isEmpty} from 'lodash'

const initialState = () => ({
    search: {}
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        search: state => state.search
    },
    actions: {
        /**
         * @param {{term: string}} params
         * @returns {Promise<*>}
         */
        globalSearch: async ({commit, dispatch}, params) => {
            try {
                let {data} = await api.globalSearch(params)

                data = isEmpty(data) ? {} : data

                commit(mutationTypes.SET_SEARCH, data)
                return data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetSearch: ({commit}) => commit(mutationTypes.RESET_SEARCH)
    },
    mutations: {
        [mutationTypes.RESET_SEARCH]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_SEARCH]: (state, data) => state.search = data
    }
}
